import i18n from 'src/i18n';
const configTable = () => {
    const tableColumns = [
        {
            prop: 'name',
            label: i18n.t('common_words.name'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'long',
            label: i18n.t('common_words.long'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'wide',
            label: i18n.t('common_words.wide'),
            align: 'center',
            sortable: true,
        }
    ];
    
    return { tableColumns };
}

export default configTable;